import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["onBlur"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useMemo } from 'react';
import { Input } from '@Sage/hoi-poi-ui';
function Integer(_ref) {
  let {
      onBlur
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const overrides = useMemo(() => ({
    input: {
      onKeyPress: e => {
        e = e || window.event;
        const charCode = typeof e.which == 'undefined' ? e.keyCode : e.which;
        const charStr = String.fromCharCode(charCode);
        if (!charStr.match(/^[0-9]+$/)) e.preventDefault();
      },
      onBlur: e => {
        var _e$target;
        const value = (_e$target = e.target) !== null && _e$target !== void 0 && _e$target.value ? parseInt(e.target.value, 10) : null;
        onBlur && onBlur(_objectSpread(_objectSpread({}, e), {}, {
          target: _objectSpread(_objectSpread({}, e.target), {}, {
            value
          })
        }));
      }
    }
  }), [onBlur]);
  return /*#__PURE__*/React.createElement(Input, _extends({
    labelMode: "horizontal",
    type: "number",
    placeholder: "0",
    overrides: overrides
  }, props));
}
export default Integer;